@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.validator {
  &Tooltip {
    display: flex;
    justify-content: center;

    &Text {
      color: map.get(core.$colors, dark);
      transform: translate(-10%);
      z-index: 10;
    }
  }

  &Indicator {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px;
    border: 1px solid map.get(core.$colors, secondaryBlue);
    border-radius: 50%;
  }
}
